import ReactApexChart from "react-apexcharts";

export default function GameChartPW(props) {
  const { chartData } = props;

  const series = [
    {
      name: "Total Concluídos",
      data:
        chartData && chartData.length > 0
          ? chartData.map((e) => Number(e.totalCompleted))
          : [],
    },
  ];

  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    colors: ["#04724c"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories:
        chartData && chartData.length > 0
          ? chartData.map((e) => e.empresa)
          : [],
    },
    yaxis: {
      title: {
        text: "Quantidade de Participantes",
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    legend: {
      show: false,
    },
  };

  const barWidth = 80;
  const chartWidth = options.xaxis.categories.length * barWidth;

  return (
    <div style={{ overflowX: "auto" }}>
      <div style={{ minWidth: chartWidth }}>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={350}
        />
      </div>
    </div>
  );
}
